import { isString } from 'lodash';
import { ALL_COLORS, Color } from 'components/colors';
import { initials } from 'utils/initials';

export const getRandomColor = (
  seed: number | string,
  palette?: Color[],
): Color => {
  const _palette = palette ?? ALL_COLORS;

  if (isString(seed)) {
    const initialsString = initials(seed);
    let colorIndex = 0;

    [...initialsString].forEach((char, index) => {
      colorIndex += initialsString.charCodeAt(index);
    });

    colorIndex -= 'A'.charCodeAt(0);

    return _palette[Math.ceil(colorIndex) % _palette.length];
  }

  return _palette[Math.ceil(seed) % _palette.length];
};

export const convertColorString = (colorString: string) => {
  // Check if the string is already in hex format
  if (colorString.startsWith('#')) {
    // Check if the length is valid for hex color
    if (
      colorString.length === 4 ||
      colorString.length === 7 ||
      colorString.length === 9
    ) {
      return colorString?.toUpperCase();
    }
    // Handle invalid hex color length

    return null;
  }

  // Extract RGBA values from the string
  const values = colorString.match(/\d+(\.\d+)?/g);

  if (!values || values.length < 3) {
    // Invalid input, return an error or default value

    return null;
  }

  // Convert RGB values to hexadecimal
  const [r, g, b, a = 1] = values.map(Number);
  const alpha = Math.round(a * 255).toString(16);

  // Ensure the hexadecimal values have two digits
  const red = `0${r.toString(16)}`.slice(-2);
  const green = `0${g.toString(16)}`.slice(-2);
  const blue = `0${b.toString(16)}`.slice(-2);

  // Combine the values and return the hex color
  return `#${red}${green}${blue}${alpha}`?.toUpperCase();
};

const componentToHex = (c: number) => {
  const hex = c.toString(16);

  return hex.length === 1 ? `0${hex}` : hex;
};

export const rgbaToHex = (r: number, g: number, b: number, a = 100) => {
  const red = componentToHex(r);
  const green = componentToHex(g);
  const blue = componentToHex(b);
  const alpha = Math.round(a * 255).toString(16);

  if (alpha === 'ff') {
    return `#${red}${green}${blue}`;
  }

  return `#${red}${green}${blue}${alpha}`;
};

export const isHex = (str: string) => {
  // Define a regular expression for a valid hexadecimal number
  const hexRegex = /^[0-9A-Fa-f]+$/g;

  // Test the string against the regular expression
  return hexRegex.test(str);
};
